module.exports = __webpack_public_path__ + "img/faturaniyukleel@3x.861bec24.png";